/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  Paper,
} from '@mui/material';
import Loading from '../Loading';
import api from '../../utils/functions/api';
import { useNavigate } from 'react-router-dom';

import QRCode from './QRCode';
import QRCredit from './QRCredit';
import QRAllInOne from './QRAllInOne';

import CreditCardPopup from './CreditCard';

import QrCodeIcon from '@mui/icons-material/QrCode';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import QrCode2Icon from '@mui/icons-material/QrCode2';

import thai_qr_logo from '../../assets/images/thai_qr_logo.png';
import creditcardLogo from '../../assets/images/CreditCardImage1.png';
import thaiFlag from '../../assets/images/Flag_of_Thailand.svg.png';
import earthLogo from '../../assets/images/icons8-earth-100.png';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import PromptPay_logo from '../../assets/images/PromptPay-logo.png';

const CreditCardPopUp = ({
  open,
  onClose,
  language,
  tokens,
  bank,
  etaxData,
  orderId,
  companyName,
  payType,
  dialogTermsOpen,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const installmentBank = bank?.find((item) => item.payType.startsWith('CR'));
  const bankDetails = installmentBank?.banks || [];

  const [qrOpen, setQrOpen] = useState(false);
  const [qrCreditOpen, setQrCreditOpen] = useState(false);
  const [qrAllInOneOpen, setQrAllInOneOpen] = useState(false);

  const urlOPS = useRef(null);
  const formOPS = useRef(null);

  const [qrCodeImage, setQrCodeImage] = useState('');
  const [merchId, setMerchantId] = useState('');
  const [callCompany, setCallCompany] = useState('');
  const [paymentRefId, setPaymentRefId] = useState('');
  const [intervalId, setIntervalId] = useState(null);
  const [bankImage, setBankImage] = useState('');
  const [nameAccount, setNameAccount] = useState('');
  const [accountNumber, setAccuontNumber] = useState('');
  const checkInterval = useRef(null);

  const handleCloseQrPopup = () => {
    setQrOpen(false);
    setSelectedMethod('');
  };

  const handleCloseQrCreditPopup = () => {
    setQrCreditOpen(false);
    setSelectedMethod('');
  };

  const handleCloseQrAllinOnePopup = () => {
    setQrAllInOneOpen(false);
    setSelectedMethod('');
  };

  const qrOptions = [
    {
      label: 'Credit Card',
      value: 'Credit Card',
      icon: (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '15px',
              marginBottom: '15px',
            }}
          >
            <img
              src={thaiFlag}
              alt="Thai QR Logo"
              style={{
                height: 40,
              }}
            />
          </div>
          <Typography variant="body1" color="text.primary">
            {language === 'TH'
              ? 'บัตรเครดิต ( เฉพาะในประเทศไทย )'
              : 'Credit Card ( Thailand Only )'}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {language === 'TH'
              ? 'ใช้ได้กับบัตรที่ออกโดยธนาคารในประเทศไทย'
              : 'Only cards issued by banks in Thailand are accepted'}
          </Typography>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '15px',
              marginBottom: '15px',
            }}
          >
            <img
              src={creditcardLogo}
              alt="Thai QR Logo"
              style={{
                height: 40,
              }}
            />
          </div>
        </>
      ),
    },
    {
      label: 'Credit Card',
      value: 'Credit Card Foreign',
      icon: (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '15px',
              marginBottom: '15px',
            }}
          >
            <img
              src={earthLogo}
              alt="Earth Logo"
              style={{
                height: 40,
              }}
            />
          </div>
          <Typography variant="body1" color="text.primary">
            {language === 'TH'
              ? 'บัตรเครดิต ( ต่างประเทศ )'
              : 'Credit Card ( Foreign )'}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {language === 'TH'
              ? 'ใช้ได้กับบัตรเครดิตโดยธนาคารต่างประเทศ'
              : 'Only cards issued by foreign banks are accepted'}
          </Typography>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              mt: { xs: 5, sm: 5, md: 5, lg: 2 },
              mb: 2,
            }}
          >
            <img
              src={creditcardLogo}
              alt="Thai QR Logo"
              style={{
                height: 40,
              }}
            />
          </Grid>
        </>
      ),
    },
  ];

  const filteredQrOptions = qrOptions
    .map((option) => {
      const matchedBank = bankDetails.find((b) => b.name === option.value);
      if (matchedBank) {
        return {
          ...option,
          bankName: matchedBank.bankName,
          // icon: matchedBank.icon,
          fee: matchedBank.fee,
          total_amount: matchedBank.total_amount,
          payType: matchedBank.payType,
        };
      }
      return null;
    })
    .filter(Boolean);
  const handlePaymentClick = async () => {
    setIsLoading(true);
    console.log('selectedMethod', selectedMethod);
    const CreditBank = bank[0].bankName;
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment`,
        {
          source: `${selectedMethod.payType} ${selectedMethod.bankName} ${
            etaxData?.branchCode ?? ''
          } ${etaxData?.tax ?? ''} ${etaxData?.postalCode ?? ''}`,
          eTaxData: {
            BUYER_NAME: etaxData?.name,
            BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
            BUYER_TAX_ID: etaxData?.taxId,
            BUYER_BRANCH_ID: etaxData?.branchCode,
            BUYER_POST_CODE: etaxData?.postalCode,
            BUYER_ADDRESS_LINE1: etaxData?.address,
            BUYER_ADDRESS_LINE2: etaxData?.address2,
          },
          etaxname: etaxData?.etaxname ?? '',
          etaxaddress1: etaxData?.etaxaddress1 ?? '',
          etaxaddress2: etaxData?.etaxaddress2 ?? '',
          email: etaxData?.email ?? '',
          term: payType === 'IN' ? etaxData?.term : null,
          card_id: etaxData?.select_card?.card_id ?? '',
        },
        { headers: { Authorization: tokens } },
      );
      if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && !data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else {
        console.log('data', data);
        urlOPS.current = data.tagUrl;
        formOPS.current = data.tagInput;
        setIsLoading(false);
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  const checkPaymentRefId = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_APIHOST}/check_callback`,
        { headers: { Authorization: tokens, sub: paymentRefId } },
      );
      if (response.status === 200) {
        const { rmsg, status, tagUrl, tagInput } = response.data;
        if (rmsg === 'pending') {
          navigate(`/transactionResult?status=${rmsg}`);
        }
        if (rmsg === 'cancel') {
          clearInterval(intervalId); // Stop the interval if the payment is canceled
          navigate(`/transactionResult?status=${rmsg}`);
        }
        clearInterval(intervalId); // Stop the interval if the payment is successful
        if (status === 'call merchant') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'call merchant jwt') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'do not call merchant') {
          clearInterval(intervalId);
          const etaxResponse = await api.post(
            `${process.env.REACT_APP_APIHOST}/etax/signandgetdocument`,
            { paymentRef: paymentRefId },
          );
          const data2 = etaxResponse.data || '';
          if (data2.status === 'OK') {
            clearInterval(intervalId);
            const urlPDF = data2.pdfURL;
            window.location.replace(
              `/transactionResult?status=${rmsg}&urlPDF=${encodeURIComponent(
                urlPDF || '',
              )}`,
            );
          } else {
            window.location.replace(`/transactionResult?status=${rmsg}`);
          }
        }
      }
    } catch (error) {
      console.error('Error during combined API call:', error);
    }
  };

  useEffect(() => {
    return () => {
      if (checkInterval.current) {
        clearInterval(checkInterval.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (qrOpen || qrAllInOneOpen || qrCreditOpen) {
      checkPaymentRefId();
      interval = setInterval(checkPaymentRefId, 10000);
    }
    return () => clearInterval(interval);
  }, [qrOpen, qrCreditOpen, qrAllInOneOpen]);

  const submitFormToMerchant = (tagUrl, tagInput) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(tagInput, 'text/html');
    const inputs = doc.querySelectorAll('input');
    const form = document.createElement('form');
    form.action = tagUrl;
    form.method = 'POST';
    form.style.display = 'none';
    inputs.forEach((input) => {
      const inputElement = document.createElement('input');
      inputElement.type = 'hidden';
      inputElement.name = input.name;
      inputElement.value = input.value;
      form.appendChild(inputElement);
    });
    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (filteredQrOptions.length > 0) {
      if (language === 'TH') {
        const thOption = filteredQrOptions.find(
          (opt) => opt.value === 'Credit Card',
        );
        console.log('found TH:', thOption);
        if (thOption) setSelectedMethod(thOption);
      } else {
        const enOption = filteredQrOptions.find(
          (opt) => opt.value === 'Credit Card Foreign',
        );
        console.log('found EN:', enOption);
        if (enOption) setSelectedMethod(enOption);
      }
    }
  }, [language]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            // width: '800px',
            minWidth: { xs: '400px', sm: '500px', md: '600px', lg: '700px' },
          },
        }}
      >
        <Loading isLoading={isLoading} />
        <DialogTitle>
          <Box sx={{ fontWeight: 'bold', fontSize: '20px', margin: '20px' }}>
            {language === 'TH'
              ? 'เลือกรูปแบบการชำระเงิน'
              : 'Select Payment Method'}
          </Box>
        </DialogTitle>

        <DialogContent>
          {dialogTermsOpen && (
            <Box
              sx={{
                backgroundColor: '#F2F8FC',
                borderRadius: '10px',
                padding: '16px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1.5,
                // border: '1px solid #276EF1',
                // boxShadow: '0px 1.5px 2px rgba(0, 0, 0, 0.5)',
              }}
            >
              <LockOutlinedIcon sx={{ color: '#276EF1', fontSize: '56px' }} />
              <Box
                sx={{
                  fontSize: '14px',
                  color: '#333',
                  textAlign: 'center', // จัดข้อความตรงกลาง
                  width: '100%', // กำหนดความกว้างให้เต็มที่
                }}
              >
                <strong>
                  {language === 'TH'
                    ? 'เพื่อความปลอดภัย กรุณาเปิดใช้ระบบ 3D Secure'
                    : 'For your security Please enable 3D Secure'}
                </strong>
                <br />
                {language === 'TH'
                  ? ' (Verified by Visa / Mastercard) กับธนาคารผู้ออกบัตรก่อนดำเนินการชำระเงิน'
                  : ' (Verified by Visa / Mastercard) with your card issuer before proceeding with payment.'}
              </Box>
            </Box>
          )}
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ p: 1 }}
          >
            {filteredQrOptions.length === 0 ? (
              <Box sx={{ textAlign: 'center', width: '100%' }}>
                {language === 'TH'
                  ? 'ไม่พบช่องทางที่รองรับ'
                  : 'No available payment methods'}
              </Box>
            ) : (
              filteredQrOptions.map((option) => (
                <Grid item xs={6} md={6} key={option.value}>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: '20px',
                      textAlign: 'center',
                      borderRadius: '15px',
                      cursor: 'pointer',
                      border:
                        selectedMethod?.value === option.value
                          ? '2px solid #0288d1'
                          : 'none',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      },
                      minHeight: { xs: '250px', md: 'auto' },
                    }}
                    onClick={() => setSelectedMethod(option)}
                  >
                    <Box>{option.icon}</Box>
                    {/* <Typography variant="subtitle1">{option.label}</Typography> */}
                    <Typography variant="caption" color="text.secondary">
                      {language === 'TH' ? 'ค่าธรรมเนียม' : 'Fee'}: {option.fee}{' '}
                      ฿
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {language === 'TH' ? 'ยอดชำระ' : 'Total Amount'}:{' '}
                      {option.total_amount} ฿
                    </Typography>
                  </Paper>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              mb: 3,
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#FC3A3A',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'rgba(252, 58, 58, 0.1)' },
              }}
            >
              {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
            </Button>
            <Button
              onClick={handlePaymentClick}
              disabled={!selectedMethod}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#51D245',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'rgba(81, 210, 69, 0.1)' },
              }}
            >
              {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <CreditCardPopup
        open={qrOpen}
        onClose={handleCloseQrPopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <CreditCardPopup
        open={qrCreditOpen}
        onClose={handleCloseQrCreditPopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <CreditCardPopup
        open={qrAllInOneOpen}
        onClose={handleCloseQrAllinOnePopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
    </>
  );
};

export default CreditCardPopUp;
